<template>
  <div class="mb-3 rm-child-margin">
    <v-dialog v-model="showRemoveRecruiter" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          $t('remove-recruiter-modal-title', { selectedRecruiterName })
        }}</v-card-title>
        <v-card-text>{{ $t('remove-recruiter-modal-text') }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ui-inline spacer-y="0">
            <v-btn color="primary" flat @click="confirmRemoveRecruiter">{{ $t('remove-recruiter-confirm-btn') }}</v-btn>
            <v-btn color="primary" flat @click="cancelRemoveRecruiter">{{ $t('remove-recruiter-cancel-btn') }}</v-btn>
          </ui-inline>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <template v-if="me !== undefined">
      <v-card v-for="recruiter in recruiters" :key="recruiter.id" class="mb-3">
        <v-container class="pa-3" grid-list-lg>
          <v-layout>
            <v-flex>
              <strong class="d-block font-weight-medium">{{ recruiter.firstName }} {{ recruiter.lastName }}</strong>
              <span class="d-block" style="word-break: break-all;">{{ recruiter.email }}</span>
            </v-flex>
            <v-flex v-if="isNotCurrentUser(recruiter)" shrink>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn flat icon color="red" class="ma-0" v-on="on" @click="removeRecruiter(recruiter)">
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('remove-recruiter-btn') }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </template>
  </div>
</template>

<script>
import gql from 'graphql-tag'

const GET_USER_ID = gql`
  query UserId {
    me {
      id
    }
  }
`

export default {
  data() {
    return {
      selectedRecruiter: null,
      showRemoveRecruiter: false
    }
  },
  apollo: {
    me: {
      query: GET_USER_ID
    }
  },
  computed: {
    isNotCurrentUser: function() {
      return recruiter => recruiter.id !== this.me.id
    },
    selectedRecruiterName: function() {
      if (this.selectedRecruiter === null) {
        return ''
      }

      return `${this.selectedRecruiter.firstName} ${this.selectedRecruiter.lastName}`
    },
    recruiters: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  props: {
    removeFunction: {
      type: Function,
      required: true
    },
    companyId: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  methods: {
    confirmRemoveRecruiter: function() {
      this.removeFunction(this.companyId, this.selectedRecruiter.id)

      this.selectedRecruiter = null
      this.showRemoveRecruiter = false
    },
    cancelRemoveRecruiter: function() {
      this.selectedRecruiter = null
      this.showRemoveRecruiter = false
    },
    removeRecruiter: function(recruiter) {
      this.selectedRecruiter = recruiter
      this.showRemoveRecruiter = true
    }
  }
}
</script>
